import React from 'react';
import { bool, func, string } from 'prop-types';

import Col from 'ravenjs/lib/Col';
import Row from 'ravenjs/lib/Row';
import Typography from 'ravenjs/lib/Typography';
import Checkbox from 'ravenjs/lib/CheckboxNew';

import { sanitizeMarkup } from 'utils/sanitize';
import MESSAGES from 'constants/messages';

import { CheckboxEmptyIcon, CheckboxFilledIcon } from '../Icons';

const PackageWarning = ({
    confirmSelection,
    configLicenseName,
    description,
    skuLicenseName,
    handleOnChange,
}) => {
    return (
        <Col margin="1rem">
            <Row>
                <Typography
                    dangerouslySetInnerHTML={sanitizeMarkup(description)}
                    gutterTop="0"
                    gutterBottom="1rem"
                    fontFamily="Roboto"
                />
            </Row>
            <Row>
                <Typography color="error" type="required" gutterBottom="0">
                    Required
                </Typography>
            </Row>
            <Row alignItems="center">
                <Typography fontSize="1rem" fontWeight="Bold" gutterBottom="0">
                    {MESSAGES.MODAL.PACKAGE.PACKAGE_CHANGE.CURRENT_PACKAGE}
                </Typography>
                <Typography gutterLeft="0.25rem" gutterTop="0.4rem" gutterBottom="0">
                    {skuLicenseName}
                </Typography>
            </Row>
            <Row>
                <Typography>
                    ({MESSAGES.MODAL.PACKAGE.PACKAGE_CHANGE.PREV_PACKAGE}
                    {configLicenseName})
                </Typography>
            </Row>
            <Row>
                <Col size="10px" padding="0.45rem 0" margin="0 0.3rem">
                    <Checkbox
                        checked={confirmSelection}
                        onChange={handleOnChange}
                        icon={CheckboxEmptyIcon}
                        checkedIcon={CheckboxFilledIcon}
                    />
                </Col>
                <Col>
                    <Typography>{MESSAGES.MODAL.PACKAGE.PACKAGE_CHANGE.CHECKBOX_LABEL}</Typography>
                </Col>
            </Row>
        </Col>
    );
};

PackageWarning.propTypes = {
    confirmSelection: bool.isRequired,
    configLicenseName: string.isRequired,
    description: string.isRequired,
    skuLicenseName: string.isRequired,
    handleOnChange: func.isRequired,
};

export default PackageWarning;
